<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId")
      button.button.small(slot="trigger") Vehicles
      h2 Segment SG{{segment.id}} {{segment.name}}
      label Vehicles
      SelectizeVehicle(:maxItems="null", @optionSelected="add" ref="select")
      ActionButton(:disabled="selected.delete.length || !selected.add.length", :action="saveVehicles") Add
      base-list(:component="component", componentType="federationList", v-model="selected.delete", :dataLoader="dataLoader", :selectableList="true", :resultsPerPage="5", ref="list")
      template(slot="footer")
        ActionButton(:disabled="selected.delete.length === 0", :action="deleteVehicles") Delete
          span(v-if="selected.delete.length" ) &nbsp;{{selected.delete.length}}

      //Attributes(v-model="body.attributes", :save-action="updateAttribute", :delete-action="deleteAttribute" )

</template>

<script>
import ModalReveal from "../../components/structure/foundation/ModalReveal";
import Attributes from "../../components/backoffice/tabbed/Attributes";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";

import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle";
import BaseList from "./BaseList";
import ActionButton from "../../components/structure/ui/ActionButton";

export default {
  name: "SegmentSlotsReveal",
  components: {ActionButton, BaseList, SelectizeVehicle, Attributes, ModalReveal},
  data() {
    return {
      entity: null,
      component: require('src/components/backoffice/Vehicle.vue'),
      loadedItems: [],
      selected: {

        add: [],
        delete: [],

      },
      body: {
        name: []

      }
    }
  },
  methods: {
    add(val) {
      this.selected.add.push(val.id)
    },

    saveVehicles() {
      const body = {
        vehicles: this.selected.add
      }
      return KeplerBackofficeSdk.segments.select(this.segment.id).addVehicles(body, () => {
        this.$refs.list.loadData(1)
        this.$refs.select.clearSelected()
        this.selected.add = []
      })
    },
    deleteVehicles() {
      const body = {
        vehicles: this.selected.delete
      }
      return KeplerBackofficeSdk.segments.select(this.segment.id).removeVehicles(body, () => {
        this.$refs.list.loadData(1)
        this.$refs.select.clearSelected()
        this.selected.delete = []
      })
    },
    dataLoader(callback, page, resultsPerPage) {
      KeplerBackofficeSdk.segments.select(this.segment.id).vehicles(page, resultsPerPage, (data) => {
        callback(data)
      })
    },
  },

  computed: {
    componentId() {
      return `segmentVehicleReveal-${this.segment.id}`
    },

  },

  props: {
    segment: {
      type: Object,
      default: null
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SegmentSlotsReveal.vue?572a55c7